import React, { Component } from 'react';
import firebase from '../firebase.js';
import ding from '../sound/order_ding.wav';

import Sidebar from './Sidebar.js';
import IncomingOrders from './Dashboard/IncomingOrders.js';
import CompletedOrders from './Dashboard/CompletedOrders.js';

export default class Dashboard extends Component {
    constructor(props){
        super(props);
        this.state = {
            currentUser: null,
            hotel: null,
            incomingOrders: [],
            completedOrders: [],
            ordersInView: '',
            noIncoming: true,
            orderCount: 0,
            orderDelay: null,
            restaurantOpen: null
        }
    }

    componentDidMount(){
        let app = this;
        firebase.auth().onAuthStateChanged(function(user) {
            if (user) {
                app.setState({
                    currentUser: user
                });

                firebase.database().ref('/Hotels/accounts/'+user.uid).once('value').then(function(snapshot) {
                    if (snapshot.val()) {
                        let delay = snapshot.val().delay;
                        let open = snapshot.val().open;
                        app.setState({
                            hotel: snapshot.val(),
                            orderDelay: delay,
                            restaurantOpen: open
                        })
                        app.getIncomingOrders();
                        app.getCompletedOrders();

                    } else {
                        console.log('log 1');
                        app.props.history.push('/');
                    }
                });

            } else {
                console.log('log 2');
                app.props.history.push('/');
            }
        });

    }

    getIncomingOrders() {
        let app = this;
        firebase.database().ref('/Hotels/orders/'+ this.state.currentUser.uid).orderByChild("completed").equalTo(false).on('value', function(snapshot) {
            let orderArr = [];
            if (snapshot.val()) {
                let orderResponse = snapshot.val();
                Object.keys(orderResponse).forEach(function (key, index) {
                    var orderForArr = orderResponse[key];
                    orderForArr.order_id = key;
                    orderArr.push(orderForArr);
                });
                if (app.state.incomingOrders && app.state.ordersInView !== '') {
                    if (app.state.incomingOrders.length < orderArr.length) {
                        let ding_sound = new Audio(ding);
                        ding_sound.play();
                    }
                }
                    orderArr.reverse();
            }
            app.setState({
                incomingOrders: orderArr,
                orderCount: orderArr.length,
                ordersInView: 'incoming'
            });
        })
    }
    getCompletedOrders(){
        let app = this;
        firebase.database().ref('/Hotels/orders/'+ this.state.currentUser.uid).orderByChild("completed").equalTo(true).on('value', function(snapshot) {
            let orderArr = [];
            if (snapshot.val()) {
                let orderResponse = snapshot.val();
                Object.keys(orderResponse).forEach(function(key,index) {
                    var orderForArr = orderResponse[key];
                    orderForArr.order_id = key;
                    orderArr.push(orderForArr);
                });
                orderArr.reverse();
            }
            app.setState({
                completedOrders: orderArr
            });
        })
    }
    goToIncoming() {
        console.log("going to incoming.");
        let app = this;
        app.setState({
            ordersInView: 'incoming'
        });
    }
    goToCompleted() {
        console.log("going to completed.");
        let app = this;
        app.setState({
            ordersInView: 'completed'
        });
    }
    updateDelay(e) {
        let path = '/Hotels/accounts/' + this.state.hotel.hotelId ;
        let oDelay = e.target.value;
        this.setState({
            orderDelay: oDelay
        });
        firebase.database().ref(path).update({
            delay: oDelay
        });
        var min = e.target.min,
            max = e.target.max,
            val = e.target.value;

        e.target.style.backgroundSize = (val - min) * 100 / (max - min) + '% 100%';
    }
    toggleRestaurantOpen(e) {
        let path = '/Hotels/accounts/' + this.state.hotel.hotelId;

        firebase.database().ref(path).update({
            open: !this.state.restaurantOpen
        });
        this.setState({
            restaurantOpen: !this.state.restaurantOpen
        });
    }

    render() {
        if(this.state.currentUser && this.state.hotel ) {
            let tabStyle = {marginRight: '20px'};
            return(
                <div className="gridlock">
                    <Sidebar hotel={this.state.hotel}/>
                    <div className="main-content">
                        <div className="top-bar">

                            <ul>
                                <li onClick={this.goToIncoming.bind(this)} className={this.state.ordersInView === 'incoming' ? 'active-tab' : ''}><span style={tabStyle}>{this.state.orderCount}</span>Incoming</li>
                                <li onClick={this.goToCompleted.bind(this)} className={this.state.ordersInView === 'completed' ? 'active-tab' : ''}>Completed</li>
                            </ul>
                            <div className="open-switch">
                               <p>{this.state.restaurantOpen ? 'Open' : 'Closed'}</p>
                                <label className="switch">
                                  <input onChange={(e) => {this.toggleRestaurantOpen(e)}} type="checkbox" defaultChecked={this.state.restaurantOpen ? 'checked' : ''} />
                                  <span className="slider round"></span>
                                </label>
                            </div>
                        </div>
                        <div className="delay-slider">
                            <div className="info-cont"><span>{this.state.orderDelay}min</span> Delay</div>
                            <div className="slider-cont">
                                <input type="range" min="0" max="60" onChange={(e) => {this.updateDelay(e)}} value={this.state.orderDelay}/>
                            </div>
                        </div>
                        {this.state.ordersInView === 'incoming' ? (
                            <IncomingOrders orders={this.state.incomingOrders} hotelId={this.state.hotel.hotelId} />
                        ) : ('')}

                        {this.state.ordersInView === 'completed' ? (
                            <CompletedOrders orders={this.state.completedOrders} restaurantName={this.state.hotel.hotelName} />
                        ) : ('')}
                    </div>
                </div>
            )
        }else{
            return(
                <div>Loading...</div>
            )
        }

    }
}


// WEBPACK FOOTER //
// ./src/components/Dashboard.js